module.exports = __webpack_public_path__ + "static/media/rin.500e32c3.svg";